module.exports = __webpack_public_path__ + "static/media/volley_goal.45b1941d.jpg";